import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddressDto } from '../../../../core/models/address/address.dto';

@Component({
  selector: 'app-form-address',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './form-address.component.html',
  styleUrl: './form-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormAddressComponent implements OnInit {
  readonly address = input<AddressDto>({} as AddressDto);

  @Output() readonly addressChanged = new EventEmitter<AddressDto>();

  public addressForm: FormGroup;
  constructor (private fb: FormBuilder) {
    this.addressForm = this.fb.group({
      city: [''],
      country: [''],
      district: [''],
      postalCode: [''],
      street: ['']
    });
  }

  ngOnInit(): void {
    this.initialPatchValue();

    this.addressForm.valueChanges.subscribe((addressData) => {
      this.addressChanged.emit(addressData as AddressDto);
    });
  }

  private initialPatchValue(): void
  {
    this.addressForm.patchValue({
      city: this.address().city ?? '',
      country: this.address().country ?? '',
      district: this.address().district ?? '',
      postalCode: this.address().postalCode ?? '',
      street: this.address().street ?? '',
    });
  }
}
